import { render, staticRenderFns } from "./MatchResultList.vue?vue&type=template&id=78253e7b&scoped=true"
import script from "./MatchResultList.vue?vue&type=script&lang=js"
export * from "./MatchResultList.vue?vue&type=script&lang=js"
import style0 from "./MatchResultList.vue?vue&type=style&index=0&id=78253e7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78253e7b",
  null
  
)

export default component.exports